import './index.less'
import { getQuery } from '@/utils/Common'
import { getApprovalDetail, getPushDetail } from '@api/approval/index.js'

export default {
	name: 'approval',
	data: () => ({
		instanceId: '',
		castgc: '',
		type: 'approval', // 'push' or 'approval'
		message: {
			title: '',
			image: '',
			summary: '',
			sendTime: '',
			sendType: '',
			totalCount: ''
		}
	}),
	created() {
		this.init()
	},
	methods: {
		async init() {
			let { type, instanceId, CASTGC } = await getQuery(window.location.href)
			this.type = type
			this.instanceId = instanceId
			this.castgc = CASTGC
			this.getDetail()
		},
		async getDetail() {
			let params = { instanceId: this.instanceId }
			let _code, _data
			if (this.type === 'approval') {
				let { code, data } = await getApprovalDetail(params, this.castgc).catch(err => {
					console.log(err)
				})
				_code = code
				_data = data
			} else if (this.type === 'push') {
				let { code, data } = await getPushDetail(params, this.castgc).catch(err => {
					console.log(err)
				})
				_code = code
				_data = data
			}
			if (_code === '0000') {
				const { title, image, summary, sendTime, sendType, totalCount } = _data
				this.message = {
					title,
					image,
					summary,
					sendTime,
					sendType,
					totalCount
				}
			}
		},
		typeTtxt(code) {
			switch (code) {
				case 1:
					return '按条件发送'
				case 2:
					return '自定义发送'
				case 3:
					return '全量发送'
				case 4:
					return '龙民ID集合发送'
				default:
					return '未知发送类型'
			}
		}
	},
	render() {
		const { message: { image, title, summary, sendTime, totalCount, sendType }, type } = this
		const { typeTtxt } = this
		const Cell = (data) => {
			const { props: {
				label, value, noBorder
			} } = data
			return (
				<div class="cell-item" style={noBorder ? styles.border : ''}>
					<span class="cell-label">{label}</span>
					<span class="cell-value">{value}</span>
				</div>
			)
		}

		const Card = (data) => {
			if (type === 'approval') {
				return (
					<div class="card-A">
						<h2>{title}</h2>
						{
							image ? <img src={image} /> : ''
						}
						<h3>{summary}</h3>
					</div>
				)
			} else if (this.type === 'push') {
				return (
					<div class="card-B">
						<div class="left">
							<div class="icon">珑珠宝</div>
							<p class="title">{title}</p>
							<p class="info">{summary}</p>
						</div>
						<div class="right">
							{
								image ? <img src={image} /> : ''
							}
						</div>
					</div>
				)
			}
		}
		return (
			<div class="container">
				{/* <div class="topic">
					<Cell label="申请人" value={proposer} noBorder />
					<Cell label="申请时间" value={proposerDate} />
				</div> */}
				<div class="middle">
					<h2>消息详情</h2>
					<Card />
					<Cell label="发送人群" value={typeTtxt(sendType)} noBorder />
					{/* <Cell label="申请人群" value="平台-安卓；航道-C1、C2；活跃度：全部" /> */}
					<Cell label="全部人数" value={totalCount} />
					<Cell label="发送时间" value={sendTime} />
				</div>
				{/* <div class="bottom">注：模版配置详情请到 PC 端查看</div> */}
			</div>
		)
	}
}

const styles = {
	border: {
		borderTop: 0
	}
}
